export default __webpack_public_path__ + "static/media/calendarIcon.3eebe3b8.svg";